__turbopack_context__.v({
  "fadeIn": "SlickCarousel-module-scss-module__z4CVOG__fadeIn",
  "providerCardSlickCarousel": "SlickCarousel-module-scss-module__z4CVOG__providerCardSlickCarousel",
  "root": "SlickCarousel-module-scss-module__z4CVOG__root",
});
